import { List, ListItem } from "@mui/material";
import { useRef } from "react";

import HNSColors from "../../../../ui library/HNSColors";
import LoadingIndicator from "../../../Common/LoadingIndicator/LoadingIndicator";
import { SETTLEMENT_STYLES } from "../../style/styles";

import MedicalBreakdownRow from "./MedicalBreakdownRow";

export default function MedicalBreakdownTable({
  data,
  isLoading,
  isExpanded = true,
  statusOptions,
  canEdit,
  onSaveSuccess,
}) {
  const medicalTableHeaderRef = useRef(null);

  if (!isLoading && data.length === 0) {
    return (
      <div className="mt-4 flex min-h-0 flex-1">
        <div
          className="flex h-full min-h-[220px] w-full flex-1 items-center justify-center rounded-[12px] px-6 py-5 text-center text-base font-semibold"
          style={SETTLEMENT_STYLES.emptyStateCard}
        >
          Nothing To Show
        </div>
      </div>
    );
  }

  return (
    <div
      className={`mt-4 flex min-h-0 flex-1 flex-col rounded-lg ${
        isExpanded ? "overflow-hidden" : "overflow-visible"
      }`}
    >
      <div
        className="flex min-h-[48px] w-full rounded-t-lg border border-b-0 text-[13px] font-semibold"
        style={{
          ...SETTLEMENT_STYLES.subtleBorder,
          backgroundColor: HNSColors.tertiary[900],
          color: HNSColors.neutrals[300],
        }}
      >
        <div
          className="flex w-[190px] flex-none items-center justify-start border-r px-4 py-3 text-left"
          style={SETTLEMENT_STYLES.subtleBorder}
        >
          Medical
        </div>
        <div ref={medicalTableHeaderRef} className="min-w-0 flex-1 overflow-hidden">
          <div className="flex w-full min-w-[735px]">
            <div
              className="flex w-[120px] flex-none grow items-center justify-center border-r px-3 py-3 text-center"
              style={SETTLEMENT_STYLES.subtleBorder}
            >
              Initial Bill
            </div>
            <div
              className="flex w-[145px] flex-none grow items-center justify-center border-r px-3 py-3 text-center"
              style={SETTLEMENT_STYLES.subtleBorder}
            >
              Reduced To
            </div>
            <div
              className="flex w-[90px] flex-none grow items-center justify-center border-r px-3 py-3 text-center"
              style={SETTLEMENT_STYLES.subtleBorder}
            >
              Discount
            </div>
            <div
              className="flex w-[160px] flex-none grow items-center justify-center border-r px-3 py-3 text-center"
              style={SETTLEMENT_STYLES.subtleBorder}
            >
              Network Status
            </div>
            <div className="flex w-[220px] flex-none grow items-center justify-center px-3 py-3 text-center">
              Status
            </div>
          </div>
        </div>
      </div>

      <div className="relative min-h-0 flex-1">
        <List
          className={`relative z-[1] w-full rounded-b-lg border p-0 ${
            isExpanded
              ? "h-full min-h-0 overflow-x-auto overflow-y-auto"
              : "h-full min-h-0 overflow-x-scroll overflow-y-auto"
          }`}
          sx={{
            ...SETTLEMENT_STYLES.subtleBorder,
            ...SETTLEMENT_STYLES.scrollbarSx,
          }}
          onScroll={(event) => {
            if (medicalTableHeaderRef.current) {
              medicalTableHeaderRef.current.scrollLeft = event.currentTarget.scrollLeft;
            }
          }}
        >
          {isLoading ? (
            <ListItem className="h-full">
              <LoadingIndicator defaultPadding="" />
            </ListItem>
          ) : (
            data.map((detail) => (
              <MedicalBreakdownRow
                key={detail?.pk || detail?.id}
                detail={detail}
                statusOptions={statusOptions}
                onSaveSuccess={onSaveSuccess}
                canEdit={canEdit}
              />
            ))
          )}
        </List>
      </div>
    </div>
  );
}
